import React from 'react'
import useSurveyLocale from '../../../modules/locale/useSurveyLocale'

// assets
import Arrow from './Arrow'
import Mobile from './Mobile'

// styles
import style from './style.module.scss'

export interface RotateDeviceProps {
  vertical?: boolean
  locale?: string
}

export default function RotateDevice({ vertical, locale }: RotateDeviceProps) {
  const { t } = useSurveyLocale()
  const text = locale || t('questions', vertical ? 'rotatePortrait' : 'rotateLandscape')

  return (
    <div className={`${style.RotateDevice} ${vertical ? style.vertical : style.horizontal}`} data-testid="SW-Rotate">
      <div className={style.rotate}>
        <div className={style.arrow}>
          <Arrow />
        </div>
        <div className={style.phone}>
          <Mobile className={style.icon} height={80} width={48} />
        </div>
        <div className={`${style.phone} ${style.animated}`}>
          <Mobile className={style.icon} height={80} width={48} />
        </div>
      </div>
      {text && (
        <div className={style.text} data-testid="SW-Rotate-Text" dangerouslySetInnerHTML={{ __html: text }}></div>
      )}
    </div>
  )
}
